import React from 'react'
import { useData } from './DataProvider'
import { Box } from '@mui/joy'
import { Label } from './Label'
import { RadioGroup, RadioGroupItem } from '../../lib/ui/radio-group'
import { NavButton, ButtonContainer } from './Buttons'
import useTranslation from '../shared/TranslationProvider'
import StepProgressHeading from './StepProgressHeading'
import { stepDescribedBy } from './stepProgress'

const Step4 = () => {
  const {
    setCurrentStep,
    lastRoleType,
    seniorityLevel,
    seniorityLevels,
    seekingEducation,
    setLastRoleType,
    setSeniorityLevel,
    setSeekingEducation,
    lastRoleTypeValues,
    seekingEducationValues,
    step,
  } = useData()
  const { t } = useTranslation()
  const subtitleId = 'onboarding-step4-subtitle'
  return (
    <>
      <Box className="pt-10" data-testid="a11y-onboarding--step-4">
        {/* CTS-9266 — YNS-020: one h1 per step */}
        <h1
          data-onboarding-step-heading
          tabIndex={-1}
          aria-describedby={stepDescribedBy(subtitleId)}
          className="text-2xl font-bold focus:outline-none md:text-4xl"
        >
          {t('step4.title')}
        </h1>
        <StepProgressHeading>
          {t('stepper_progress', { current: step })}
        </StepProgressHeading>
        <p id={subtitleId} className="py-5 text-base md:text-xl">
          {t('step4.subtitle')}
        </p>
        <Box className="pt-2">
          <RadioGroup
            aria-labelledby="step4-last-role-type-label"
            value={lastRoleType || ''}
            onValueChange={(value) => setLastRoleType(value)}
          >
            <Label id="step4-last-role-type-label">
              {t('step4.last_role_type.description')}
            </Label>
            {lastRoleTypeValues.map(([id]) => (
              <div
                key={`role-type-${id}`}
                className="flex items-center space-x-2"
              >
                <RadioGroupItem value={id} id={`role-type-option-${id}`} />
                <Label
                  className="font-normal"
                  htmlFor={`role-type-option-${id}`}
                >
                  {t(`step4.last_role_type.${id}`)}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </Box>
        <Box className="pt-5">
          <RadioGroup
            aria-labelledby="step4-seniority-label"
            value={seniorityLevel || ''}
            onValueChange={(value) => setSeniorityLevel(value)}
          >
            <Label id="step4-seniority-label">
              {t('step4.seniority.description')}
            </Label>
            {seniorityLevels.map(([id, value]) => (
              <div
                key={`seniority-level-${id}`}
                className="flex items-center space-x-2"
              >
                <RadioGroupItem
                  value={value}
                  id={`seniority-level-option-${id}`}
                />
                <Label
                  className="font-normal"
                  htmlFor={`seniority-level-option-${id}`}
                >
                  {t(`step4.seniority.${id}`)}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </Box>
        <Box className="pt-5">
          <RadioGroup
            aria-labelledby="step4-seeking-education-label"
            value={seekingEducation || ''}
            onValueChange={(value) => setSeekingEducation(value)}
          >
            <Label id="step4-seeking-education-label">
              {t('step4.seeking_education')}
            </Label>
            {seekingEducationValues.map((value) => (
              <div
                key={`seeking-education-${value}`}
                className="flex items-center space-x-2"
              >
                <RadioGroupItem
                  value={value}
                  id={`seeking-education-option-${value}`}
                />
                <Label
                  className="font-normal"
                  htmlFor={`seeking-education-option-${value}`}
                >
                  {t(`step4.education_${value}`)}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </Box>
      </Box>
      <ButtonContainer>
        <NavButton type="back" onClick={() => setCurrentStep(3)}>
          {t('back')}
        </NavButton>
        <NavButton type="submit" onClick={() => setCurrentStep(5)}>
          {t('next')}
        </NavButton>
      </ButtonContainer>
    </>
  )
}
export default Step4
